import { Component, OnInit,HostListener } from '@angular/core';
import {commonService} from "../../service/common.service";
import { Router,ActivatedRoute, Params } from '@angular/router';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import { Alert } from 'selenium-webdriver';

@Component({
  selector: 'app-instruction',
  templateUrl: './instruction.component.html',
  styleUrls: ['./instruction.component.css','../questions/questions.component.css']
})

export class InstructionComponent implements OnInit {

  userData:any;
  paperId: any = 0;
  marked=false;
  packageList:any = [];
  isError=false;
  msg='';

  constructor(private commonService:commonService, private router:Router, private route: ActivatedRoute, private global: Globals) { }

  ngOnInit() {

    this.commonService.profile.subscribe((data:any)=>{
      if(data && Object.keys(data).length != 0){
        this.userData=data; 
      }else{
       this.userData={};
      }
    });

    this.route.params.subscribe((params: Params) => {
      if(params['id']){      
      this.paperId = parseInt( atob(params['id']) ) ;
      if(isNaN(this.paperId)){
        this.paperId=0;
        this.router.navigateByUrl('/');
      } 

      }
    });
  
}

 // DISABLE ALL KEYBOAR KEYS
 @HostListener('document:keydown', ['$event'])
 handleKeyboardEvent(event: KeyboardEvent) {
    event.returnValue = false;
    event.preventDefault();
 }

  //DISABLE RIGHT CLICK
  onRightClick(event:any) {
    return false;
  }

// SET THE PROFILE IMAGE OF STUDENT
profileImage(img) {
  let photo = img;
  if(photo==''){
    photo = "avatar.png";
  }if (!photo) {
   
  }
  let res = this.global.profileUrl + photo;
  return res;
}

startQuiz(){
 if(this.marked){
   this.router.navigateByUrl('onlineMCQ/online/questions/'+btoa(this.paperId));
 }else{
   alert('Please agree with above instructions');
 }
}

toggleVisibility(e){
  this.marked= e.target.checked;
}

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/online-mcq/instruction/instruction.component.ts